import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectionStrategy, Input } from '@angular/core';
import { AnimationEvent } from '@angular/animations';
import { ReplaySubject, BehaviorSubject, Observable, Subject } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';
import { sortOptions, SortBy, PageName, PageParams } from '@app/constants';
import { expandTabsAnimation, tabsAnimation, expandSortAnimation, expandFacetAnimation, fadeIfAnimation, facetsAnimation, ifHeightAnimation } from '@app/animations';
import { DefaultIndexDoc } from '@app/graphql';
import { SortComponent } from '../sort/sort.component';

@Component({
  selector: 'app-search-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.less'],
  animations: [expandTabsAnimation, tabsAnimation, expandSortAnimation, expandFacetAnimation, fadeIfAnimation, facetsAnimation, ifHeightAnimation]
})
export class SearchBarComponent implements OnInit, OnDestroy {

  @Input() count$!: Observable<number>;
  @Input() articles$!: Observable<DefaultIndexDoc[]>;
  @Input() status$!: Observable<string>;
  @Input() pageParams$!: Observable<PageParams>;
  @Input() pageName!: string;
  @Input() class!: string;
  @Input() scrollInToView$!: Subject<void>;

  public expanded$ = new BehaviorSubject<boolean | number>(false);
  private initiated: boolean = false;
  public selectedIndex$: BehaviorSubject<number> = new BehaviorSubject(1);
  public animationDuration$: BehaviorSubject<string> = new BehaviorSubject('0');
  private unsubscribe$: Subject<void> = new Subject();

  constructor() {}

  ngOnInit(): void {
    //console.log('SearchBarComponent ngOnInit this', this);

    this.status$.pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
      console.log('********* SearchBarComponent status$ subscribe data', data);

      if (data === 'success') {
        this.closeOptions();
      }
    }); 
  }

  ngOnDestroy(): void {

    this.unsubscribe$.next();
    this.unsubscribe$.complete();   
  }

  public controlPanel = (index: number): void => {

    const expanded = this.expanded$.value;
    const selectedIndex = this.selectedIndex$.value;

    //console.log('SearchBarComponent togglePanel index ', index);
    //console.log('SearchBarComponent togglePanel expanded ', expanded);
    //console.log('SearchBarComponent togglePanel selectedIndex ', selectedIndex);

    if (expanded === false && selectedIndex !== index) {
      this.animationDuration$.next('0');
      this.selectedIndex$.next(index);
      this.expand(index);
    }
    else if (expanded === false && selectedIndex === index) {
      /*this.animationDuration$.next('350');
      this.selectedIndex$.next(index);*/
      this.expand(index);
    }
    else if (expanded !== false && selectedIndex !== index) {
      this.animationDuration$.next('350');
      this.selectedIndex$.next(index);
      this.expand(index);
    }
    else if (expanded !== false && selectedIndex === index) {
      this.expand(false);
    }

    this.scrollInToView$.next();


  }

  private expand = (index: boolean | number): void => {

    if (!this.initiated) {
      this.initiated = true;
      //this.initiated$.next(true);
    }

    this.expanded$.next(index);
  };

  public closeOptions = (): void => {
    this.expanded$.next(false);
  };

  /*public isExpanded = (expanded: any): boolean => {
    //console.log('SearchBarComponent togglePanel expanded ', expanded);

    return expanded === false ? false : true
  };*/

  public trackByMethod = (index:number, el:any): number => el.url;

  

}
